module.exports = __webpack_public_path__ + "dd44-img-power-1.png";